
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index47A1SF9nzB9wsO_45yykMo1QET9eQZugjNieVmsON1UCAMeta } from "/home/renato/projects/apps/pj/cf236/general/general/pages/index.vue?macro=true";
import { default as atividadesQ0XJNik7CXnsC_MlIaU5Z5zCYJPQuSOEopYipmewWWQMeta } from "/home/renato/projects/apps/pj/cf236/general/general/pages/atividades.vue?macro=true";
import { default as erro_45tokenHDFdHeLAlcDm5w6k2tPm_45MnMkynrOMFRdLEVZl_45Q7HUMeta } from "/home/renato/projects/apps/pj/cf236/general/general/pages/erro-token.vue?macro=true";
import { default as authenticate_tIqNJkyKZnbpcqKzqX4emeeXUa7krB12S3MGAsCdeMMeta } from "/home/renato/projects/apps/pj/cf236/general/general/pages/authenticate.vue?macro=true";
import { default as example_45protectedNzhQxJ9M4g1g_45ZoBzXllZo2_45oUCjRUbdHTMF5xseLX0Meta } from "/home/renato/projects/apps/pj/cf236/general/general/pages/example-protected.vue?macro=true";
import { default as indexIGRaHWwQD1jAj2bxoiMh4ENAZEG3bLHrO5rwHL0PzioMeta } from "/home/renato/projects/apps/pj/cf236/general/general/pages/configuracoes/index.vue?macro=true";
import { default as permissoesfV9oo7fAyRLXCcBxR_4500PYvDB56xLK4tSWHpo8WlUA0Meta } from "/home/renato/projects/apps/pj/cf236/general/general/pages/configuracoes/permissoes.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/renato/projects/apps/pj/cf236/general/general/pages/index.vue")
  },
  {
    name: "atividades",
    path: "/atividades",
    component: () => import("/home/renato/projects/apps/pj/cf236/general/general/pages/atividades.vue")
  },
  {
    name: "erro-token",
    path: "/erro-token",
    meta: erro_45tokenHDFdHeLAlcDm5w6k2tPm_45MnMkynrOMFRdLEVZl_45Q7HUMeta || {},
    component: () => import("/home/renato/projects/apps/pj/cf236/general/general/pages/erro-token.vue")
  },
  {
    name: "authenticate",
    path: "/authenticate",
    meta: authenticate_tIqNJkyKZnbpcqKzqX4emeeXUa7krB12S3MGAsCdeMMeta || {},
    component: () => import("/home/renato/projects/apps/pj/cf236/general/general/pages/authenticate.vue")
  },
  {
    name: "example-protected",
    path: "/example-protected",
    meta: { ...(example_45protectedNzhQxJ9M4g1g_45ZoBzXllZo2_45oUCjRUbdHTMF5xseLX0Meta || {}), ...{"middleware":["validate-token","permissions"]} },
    component: () => import("/home/renato/projects/apps/pj/cf236/general/general/pages/example-protected.vue")
  },
  {
    name: "configuracoes",
    path: "/configuracoes",
    component: () => import("/home/renato/projects/apps/pj/cf236/general/general/pages/configuracoes/index.vue")
  },
  {
    name: "configuracoes-permissoes",
    path: "/configuracoes/permissoes",
    component: () => import("/home/renato/projects/apps/pj/cf236/general/general/pages/configuracoes/permissoes.vue")
  }
]